export default "__VITE_ASSET__BvdQnwNz__"